export const AlertConstants = {
    SAVE:"saved",
    DISCARD:"discarded",
    UNPUBLISH:"unpublished",
    DELETE:"deleted",
    PUBLISH:"published"
  }
    